import * as React from "react";

import { All } from "./All";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { BaseRootExtensions } from "./BaseRootExtensions";
import { Create } from "./Create";
import { Detail } from "./Detail";
import { Edit } from "./Edit";

import { Fragment, Location } from "redux-little-router";

const Base: React.FunctionComponent = () => {

    const withConditions = (l: Location) => l.params.customerSraDepartmentId === undefined;

    return (
        <div>
            <Fragment forRoute="/" withConditions={withConditions}>
                <div>
                    <All />
                    <Create />
                    <BaseItemExtensions />
                </div>
            </Fragment>
            <Fragment forRoute="/:customerSraDepartmentId">
                <div>
                    <Detail />
                    <Edit />
                    <BaseRootExtensions />
                </div>
            </Fragment>
        </div>
    );
};

export default Base;
